import { useEffect, useState } from 'react';
import { Fixture, getFixtures } from '../../services/footballApi';
import { MatchCard } from './MatchCard';

interface MatchListProps {
  type: 'next' | 'last';
  limit?: number;
  showLeague?: boolean;
}

export function MatchList({ type, limit, showLeague = true }: MatchListProps) {
  const [fixtures, setFixtures] = useState<Fixture[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchFixtures = async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await getFixtures(type, limit);
        setFixtures(data);
      } catch (err) {
        setError('Kunne ikke laste kampdata. Vennligst prøv igjen senere.');
        console.error('Failed to fetch fixtures:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchFixtures();
  }, [type, limit]);

  if (loading) {
    return (
      <div className="space-y-3">
        {[...Array(2)].map((_, i) => (
          <div key={i} className="animate-pulse bg-gray-50 rounded-lg p-4">
            <div className="h-5 bg-gray-200 rounded w-1/3 mb-3"></div>
            <div className="space-y-3">
              <div className="h-6 bg-gray-200 rounded"></div>
              <div className="h-6 bg-gray-200 rounded"></div>
              <div className="h-5 bg-gray-200 rounded w-2/3"></div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (error) {
    return (
      <div className="space-y-3">
        <div className="bg-gray-50 rounded-lg p-4">
          <p className="text-gray-600">Kampdata er midlertidig utilgjengelig.</p>
          <p className="text-sm text-gray-500 mt-2">Vennligst prøv igjen senere.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {fixtures.map((fixture) => (
        <MatchCard 
          key={fixture.fixture.id} 
          fixture={fixture}
          showLeague={showLeague}
        />
      ))}
    </div>
  );
}
